import Phaser from 'phaser';
import { globals } from './globals';
import GameManager from './GameManager';
import Bootloader from './Bootloader';
import Preload from './scenes/Preload';
import MainMenu from './scenes/MainMenu';
import LevelSelector from './scenes/LevelSelector';
import GameWinned from './scenes/GameWinned';
import GameLosed from './scenes/GameLosed';
import GamePaused from './scenes/GamePaused';
import LevelSelectorInfo from './scenes/LevelSelectorInfo';
import GameUI from './scenes/GameUI';
import GameLevel from './scenes/GameLevel';
import GameLevelDev from './scenes/GameLevelDev';
import GameLevelTest from './scenes/GameLevelTest';
import About from './scenes/About';
import Settings from './scenes/Settings';
import SettingName from './scenes/SettingName';
import Score from './scenes/Score';
import EndGame from './scenes/EndGame';
import { Capacitor } from '@capacitor/core';

const platform = Capacitor.getPlatform();
const aspectRatio = window.innerWidth / window.innerHeight;

// Game Mode
if (!globals.gameMode) {
    if (platform === 'web' && aspectRatio >= 0.99) {
        globals.gameMode = 'desktop';
    } else {
        globals.gameMode = 'mobile';
    }
}
globals.sizeWidthScreen = globals.gameMode === 'mobile' ? 540 : 1280;

const config: Phaser.Types.Core.GameConfig = {
    title: 'Phaser Game',
    version: '1.3.2',
    type: Phaser.AUTO,
    scale: {
        mode: Phaser.Scale.RESIZE,
        autoCenter: Phaser.Scale.CENTER_BOTH,
        parent: 'phaser_container',
        width: globals.sizeWidthScreen,
        height: globals.sizeHeightScreen,
        min: {
            width: globals.minSizeWidthScreen,
            height: globals.minSizeHeightScreen
        },
        max: {
            width: globals.maxSizeWidthScreen,
            height: globals.maxSizeHeightScreen
        }
    },
    pixelArt: false,
    physics: {
        default: 'matter',
        'matter': {
            gravity: {
                x: 0,
                y: 0
            },
            debug: globals.debugMode
        }
    },
    scene: [
        Bootloader,
        Preload,
        MainMenu,
        LevelSelector,
        GameWinned,
        GameLosed,
        GamePaused,
        LevelSelectorInfo,
        GameUI,
        GameLevelDev,
        GameLevelTest,
        GameLevel,
        About,
        Settings,
        SettingName,
        Score,
        EndGame
    ],
    parent: 'phaser_container',
    dom: {
        createContainer: true
    }
};

const game = new Phaser.Game(config);

new GameManager(game);
